import { ActiveAgencies, ActiveBenificaryAccount } from './ActiveClasses';
export class BaseDataBeneficiaryAccountsAllocation {
  agencies: ActiveAgencies[] = [];
  accounts: ActiveBenificaryAccount[] = [];
}
export class AllocatedBeneficiaryAccounts {
  name: string = "";
  reference: string = "";
  accountNo: string = "";
  accountTitle: string = "";
  bankName: string = "";
  branch: string = "";
  iban: string = "";
  agencyId: string = "";
  isActive: boolean;
}
